// Central site configuration — single source of truth for external references.
// Values in [BRACKETS] are placeholders the owner must fill (see handover notes).

export const WHATSAPP_PRIMARY = "+34622181686"; // Spain office
export const WHATSAPP_SECONDARY = "+34639341794"; // Dubai office

export const DUBAI_PHONE = "[DUBAI_PHONE]";
export const LEGAL_NAME = "[LEGAL_NAME]";
export const LICENSE_NUMBER = "[LICENSE_NUMBER] — Dubai South Free Zone";
export const ADDRESS = "[ADDRESS]";

// Social links — icons render only when these are non-empty.
export const INSTAGRAM_URL = "";
export const TIKTOK_URL = "";

// Inspection sample assets — buttons/sections render only when non-empty.
export const SAMPLE_REPORT_PDF = "";
export const SAMPLE_REPORT_VIDEO = "";

export const waLink = (phone, text) =>
  `https://wa.me/${phone.replace("+", "")}?text=${encodeURIComponent(text)}`;
